export const ROUTE_PATH = '/timiryazev-parking';

export const FEATURE_NAME = 'TimiryazevParkingPage';
